class NoxPumpGallery extends HTMLElement {
  connectedCallback() {
    this.panels = [...this.querySelectorAll('[data-pump-panel]')];
    this.thumbnails = [...this.querySelectorAll('[data-pump-thumbnail]')];
    this.index = this.panels.findIndex((panel) => !panel.hidden);
    this.events = new AbortController();
    this.addEventListener('click', (event) => {
      const thumbnail = event.target.closest('[data-pump-thumbnail]');
      const arrow = event.target.closest('[data-pump-direction]');
      if (thumbnail) this.select(Number(thumbnail.dataset.pumpThumbnail));
      if (arrow) this.select(this.index + Number(arrow.dataset.pumpDirection));
    }, { signal: this.events.signal });
    this.querySelector('.pump-stage').addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      this.select(this.index + (event.key === 'ArrowLeft' ? -1 : 1));
    }, { signal: this.events.signal });
  }

  select(index) {
    this.index = (index + this.panels.length) % this.panels.length;
    this.panels.forEach((panel, position) => { panel.hidden = position !== this.index; });
    this.thumbnails.forEach((button, position) => {
      button.setAttribute('aria-pressed', String(position === this.index));
    });
    this.querySelector('[data-pump-gallery-status]').textContent = `Photo ${this.index + 1} sur ${this.panels.length}`;
  }

  disconnectedCallback() {
    this.events.abort();
  }
}

class NoxPumpPurchase extends HTMLElement {
  connectedCallback() {
    this.events = new AbortController();
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-pump-quantity]');
      if (!button) return;
      const input = this.querySelector('[name="quantity"]');
      if (!input.reportValidity()) return;
      const previous = input.value;
      if (Number(button.dataset.pumpQuantity) > 0) input.stepUp();
      else input.stepDown();
      if (!input.checkValidity()) input.value = previous;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }, { signal: this.events.signal });
    this.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!this.querySelector('[name="id"]')) {
        this.closest('section').querySelector('.pump-availability').focus();
        return;
      }
      this.addToCart(event);
    }, { signal: this.events.signal });
  }

  async addToCart(event) {
    if (this.adding) return;
    const form = event.target;
    if (!form.reportValidity()) return;
    const errorMessage = this.querySelector('[data-pump-cart-error]');
    errorMessage.hidden = true;
    const buttons = [...document.querySelectorAll('button[type="submit"]')].filter((button) => button.form === form);
    const buttonStates = buttons.map((button) => button.disabled);
    this.adding = true;
    buttons.forEach((button) => {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    });
    try {
      const cart = document.querySelector('cart-drawer');
      if (!cart) throw new Error('Le panier est indisponible. Rechargez la page puis réessayez.');
      const formData = new FormData(form);
      formData.append('sections', cart.getSectionsToRender().map((section) => section.id).join(','));
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(event.submitter || document.activeElement);
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;
      const response = await fetch(window.routes.cart_add_url, config);
      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || window.cartStrings.error);
      }
      if (!result.sections || cart.getSectionsToRender().some((section) => !result.sections[section.id])) {
        throw new Error('Le produit a été ajouté, mais le panier ne peut pas être affiché. Rechargez la page pour le consulter.');
      }
      cart.classList.remove('is-empty');
      cart.renderContents(result);
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'nox-pump-purchase',
        productVariantId: formData.get('id'),
        cartData: result,
      });
    } catch (error) {
      console.error('Nox pump cart:', error);
      errorMessage.textContent = error.message || window.cartStrings.error;
      errorMessage.hidden = false;
      publish(PUB_SUB_EVENTS.cartError, {
        source: 'nox-pump-purchase',
        message: errorMessage.textContent,
        errors: errorMessage.textContent,
      });
    } finally {
      this.adding = false;
      buttons.forEach((button, index) => {
        button.disabled = buttonStates[index];
        button.removeAttribute('aria-busy');
      });
    }
  }

  disconnectedCallback() {
    this.events.abort();
  }
}

if (!customElements.get('nox-pump-gallery')) customElements.define('nox-pump-gallery', NoxPumpGallery);
if (!customElements.get('nox-pump-purchase')) customElements.define('nox-pump-purchase', NoxPumpPurchase);
